import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Table } from 'semantic-ui-react';

// Global Types
import { AppState } from 'services/types';

// Selectors
// @ts-ignore
import { makeSelectResult } from 'services/results/selectors';

// Global Components
// @ts-ignore
import ResponsiveTable from 'components/ResponsiveTable';
// @ts-ignore
import TableCountDropdown from 'components/TableCountDropdown';

// Child Components
// @ts-ignore
import TimesheetsPagination from '../TimesheetsPagination';
// @ts-ignore
import TimesheetsTableHead from './components/TimesheetsTableHead';
import TimesheetsTableRow from './components/TimesheetsTableRow';

interface ConnectedProps {
    ids?: number[];
}

type Props = ConnectedProps;

export class TimesheetsTable extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { ids } = this.props;
        return (
            <React.Fragment>
                <ResponsiveTable>
                    <Table
                        sortable
                        striped
                        singleLine
                        unstackable
                        size="small"
                        selectable
                    >
                        <TimesheetsTableHead ids={ids} />
                        <Table.Body>
                            {(!ids || !ids.length) && (
                                <Table.Row colSpan="17" textAlign="center">
                                    <Table.Cell
                                        colSpan="17"
                                        className="events-table-cell-padding"
                                    >
                                        There are no Timesheets.
                                    </Table.Cell>
                                </Table.Row>
                            )}
                            {ids &&
                                ids.map(id => (
                                    <TimesheetsTableRow
                                        key={id}
                                        timesheetId={id}
                                    />
                                ))}
                        </Table.Body>
                    </Table>
                </ResponsiveTable>
                <div style={{ display: 'flex' }}>
                    <div style={{ marginLeft: 'auto' }}>
                        <TableCountDropdown defaultCount={25} />
                        <TimesheetsPagination />
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    ids: makeSelectResult('TIMESHEETS_LOAD')
});

export default connect(mapStateToProps)(TimesheetsTable);
